module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "firstEPI"
  }, [_vm._v("Let him who seeks continue seeking")]), _vm._v(" "), _c('h1', {
    staticClass: "EPIindent"
  }, [_vm._v("until he finds.")]), _vm._v(" "), _c('h1', {
    staticClass: "EPI"
  }, [_vm._v("When he finds, he will become troubled.")]), _vm._v(" "), _c('h1', {
    staticClass: "EPIindent"
  }, [_vm._v("When he becomes troubled,")]), _vm._v(" "), _c('h1', {
    staticClass: "EPIindent"
  }, [_vm._v("he will be astonished,")]), _vm._v(" "), _c('h1', {
    staticClass: "EPIindent"
  }, [_vm._v("and he will rule over the All.")]), _vm._v(" "), _c('h1', {
    staticClass: "EPIS"
  }, [_vm._v("—"), _c('span', {
    staticClass: "ital _idGenCharOverride-1"
  }, [_vm._v("Gospel of Thomas")])]), _vm._v(" "), _c('h1', {
    staticClass: "EPI"
  }, [_vm._v("The best of prophets of the Future is the Past.")]), _vm._v(" "), _c('h1', {
    staticClass: "EPIS"
  }, [_vm._v("—Byron")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-320d8d09","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/midas-2.vue
// module id = 75
// module chunks = 0